// Form

import './index.scss';

export default class Form {
    constructor(root) {
        this.root = root;

        this.header = this.root.querySelector('.form-header');
        this.wrap = this.root.querySelector('.form-wrap');

        this.handleSuccessMessage();
        this.handleErrorMessage();
        this.copyJobOfferData();
        this.initFileInput();
    }

    handleSuccessMessage() {
        this.successMessage = this.wrap.querySelector('.form-success-message');
        if (this.successMessage) {
            this.header.style.display = 'none';

            let popup = this.successMessage.closest('.popup');
            if (popup) {
                popup.querySelectorAll('.overlay, .panel__close, [data-popup-close]').forEach((button) => {
                    button.addEventListener('click', (event) => {
                        history.replaceState("", "", location.pathname);
                    });
                });
            }
        }
    }

    handleErrorMessage() {
        this.errorMessage = this.wrap.querySelector('.form-error-message');
        if (this.errorMessage && this.wrap.querySelectorAll('.has-error').length) {
            this.errorMessage.style.display = 'block';
        }
    }

    copyJobOfferData() {
        let jouSrc = this.header.querySelector('[data-joboffer-uid]');
        let jouDst = this.wrap.querySelector('[id$="-joboffer-uid"]');
        if (jouSrc && jouDst) {
            jouDst.value = jouSrc.dataset.jobofferUid;
        }

        let jopSrc = this.header.querySelector('[data-joboffer-pool]');
        let jopDst = this.wrap.querySelector('[id$="-joboffer-pool"]');
        if (jopSrc && jopDst) {
            jopDst.value = jopSrc.dataset.jobofferPool;
        }

        let jonSrc = this.header.querySelector('[data-joboffer-name]');
        let jonDst = this.wrap.querySelector('[id$="-joboffer-name"]');
        if (jonSrc && jonDst) {
            jonDst.value = jonSrc.dataset.jobofferName;
        }

        let jolSrc = this.header.querySelector('[data-joboffer-location]');
        let jolDst = this.wrap.querySelector('[id$="-joboffer-location"]');
        if (jolSrc && jolDst) {
            jolDst.value = jolSrc.dataset.jobofferLocation;
        }
    }

    initFileInput() {
        this.wrap.querySelectorAll('input[type="file"]').forEach((file) => {
            let defaultLabel = 'Datei-Upload';

            let pn = file.parentNode;
            pn.classList.add('input-file');

            let i = document.createElement('i');
            i.classList.add('icon-file-upload');
            pn.appendChild(i);

            let s = document.createElement('span');
            s.classList.add('file-name');
            s.innerHTML = defaultLabel;
            pn.appendChild(s);

            file.addEventListener('change', (event) => {
                let names = [];
                Array.from(event.target.files).forEach((file) => {
                    names.push(file.name);
                });

                let label = names.join(',<br>');
                if (!label) {
                    label = defaultLabel;
                }

                s.innerHTML = label;
            });
        });
    }
}
